export default __webpack_public_path__ + "static/media/icon7.dfd67673.svg";